<template>
	<ul class="v-resume-paginator">
		<li 
			class="v-resume-paginator__item" 
			:class="{
				'active': activeTab == option.id,
				'is_mobile': option.isMobile
			}"
			v-for="option in list" 
			:key="`paginator_option_${option.id}`" 
			@click="updateTab(option.id)">
			{{ option.title }}
		</li>
	</ul>
</template>
<script>
export default {
	props: {
		options: Array,
		activeTab: String,
		hasApplicationTab: Boolean
	},
	computed: {
		list() {
			return this.options.filter(item => {
				if (item.id === 'application') {
					return !!this.hasApplicationTab
				}
				return true;
			})
		}
	},
	methods: {
		updateTab(tab) {
			this.$emit('updateTab', tab)
		}
	}
}
</script>
<style lang="scss" scoped>
.v-resume-paginator {
	padding: 0;
	list-style-type: none;
	display: flex;
	align-items: center;
	justify-content: flex-start;

	@media only screen and (max-width: 480px) {
      justify-content: center;
    }

	&__item {
		cursor: pointer;
		user-select: none;
		position: relative;
		color: #8D8D8D;
		padding: 0 20px;
		font-weight: 500;
		font-size: 15px;
		line-height: 24px;
		transition: color .4s ease;

		&:first-child {
			padding-left: 12px;

			&:before {
				left: 0px;
			}
		}

		&.active {
			color: #555555;

			&:before {
				opacity: 1;
			}
		}

		&:before {
			position: absolute;
			content: "";
			border-radius: 50%;
			height: 6px;
			width: 6px;
			background-color: #53D93A;
			left: 8px;
			top: calc(50% - 3px);
			opacity: 0;
			transition: opacity .4s ease;
		}

		&:not(:first-child):after {
			content: "";
			position: absolute;
			left: 0;
			top: calc(50% - 6px);
			height: 12px;
			width: 0px;
			border-left: 1px solid #D1D8E0;
		}

		&.is_mobile {
			display: none;

			@media only screen and (max-width: 480px),
      		only screen and (max-width: 1000px) and (orientation: landscape) {
				display: block;
			}
		}
	}
}
</style>